import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { QueryClientProvider } from "@tanstack/react-query";
export const WithQueryClient = (queryClient)=>(Component)=>{
        const Wrapped = (props)=>{
            return /*#__PURE__*/ _jsx(QueryClientProvider, {
                client: queryClient,
                children: /*#__PURE__*/ _jsx(Component, {
                    ...props
                })
            });
        };
        return Wrapped;
    };
